/**
 * Lifely App Version
 * Increment this when making changes:
 * - Major (x.0.0): Breaking changes, major features
 * - Minor (0.x.0): New features, significant updates  
 * - Patch (0.0.x): Bug fixes, small improvements
 */

export const APP_VERSION = '1.0.0';

export const VERSION_HISTORY = [
  {
    version: '1.0.0',
    date: '2025-02-06',
    changes: [
      'Initial versioned release',
      'Account deletion with email confirmation',
      'Continuity check-in system with Resend emails',
      'Cron-based reminder scheduling',
      'Full D1 database integration',
      'Memberstack authentication',
    ]
  }
];
